import React from 'react';
import { ActivityIndicator, Modal, View } from 'react-native';
import styles from './styles';
const ScreenLoader = ({ loading }) => {
  return (
    <Modal
      transparent={true}
      animationType={'fade'}
      visible={loading}
      onRequestClose={() => { console.log('close modal') }}>
      <View style={styles.modalBackground}>
        <View style={styles.activityIndicatorWrapper}>
          <ActivityIndicator animating={loading} color="#2797A2" size="large" />
        </View>
      </View>
    </Modal>
  )
}
export default ScreenLoader;